import { shouldUpdate } from "recompose";
import { isEqualIgnoreFunctions } from "./isEqualIgnoreFunctions";
const pure = (BaseComponent) => {
  const hoc = shouldUpdate(
    (props, nextProps) => !isEqualIgnoreFunctions(props, nextProps)
  );
  return hoc(BaseComponent);
};
export default pure;
